import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-generateparams',
  templateUrl: './generateparams.component.html',
  styleUrls: ['./generateparams.component.css']
})
export class GenerateparamsComponent implements OnInit {
  @Input()
  title: string;

  @Input()
  message: string;

  @Output()
  onConfirmDone = new EventEmitter<boolean>();

  public visibleConfirm = true;
  private visibleConfirmAnimate = false;

  constructor() {
  }

  formDone(result: boolean) {
    //console.log("confirmation modal: formDone(), pressed value: " + result);
    this.onConfirmDone.emit(result);  // send signal back to caller with result (confirm (=true) or cancel (=false))
  }

  ngOnInit() {
    this.show();
  }

  ngOnChanges() {
  }

  public show(): void {
    this.visibleConfirm = true;
    setTimeout(() => this.visibleConfirmAnimate = true);
  }

  public hide(): void {
    this.visibleConfirmAnimate = false;
    setTimeout(() => this.visibleConfirm = false, 300);
  }


}
